import { 
  fontSizeParagraph,
  lineHeightGlobal
}  from "../../utils/pdfConstants";



export function renderTextarea({ data, content}) {
  const raw = data?.value || "";

  const marker = "Käytetyt kuntoluokat ovat:";
  const index = raw.indexOf(marker);

  if (index !== -1) {
    const before = raw.substring(0, index).trim();
    const after = raw.substring(index + marker.length).trim();

    // Text before the marker
    if (before) {
      content.push({
        text: before,
        style: "paragraph",
        margin: [0, 0, 0, 0],
      });
    }

    // The KL legend block
    content.push({
      stack: [
        {
          text: "Käytetyt kuntoluokat ovat:",
          bold: true,
          fontSize: fontSizeParagraph,
          margin: [0, 2, 0, 4],
        },
        {
          text: [
            { text: "KL 5", bold: true, color: "#04aa00" },
            { text: " Uusi, ei toimenpiteitä seuraavan 10 vuoden kuluessa\n" },

            { text: "KL 4", bold: true, color: "#04aa00" },
            { text: " Hyvä, kevyt huoltokorjaus 6–10 vuoden kuluessa\n" },

            { text: "KL 3", bold: true, color: "#FFC107" },
            { text: " Tyydyttävä, kevyt huoltokorjaus 1–5 vuoden kuluessa tai peruskorjaus 6–10 vuoden kuluessa\n" },

            { text: "KL 2", bold: true, color: "#ba3b46" },
            { text: " Välttävä, peruskorjaus 1–5 vuoden kuluessa tai uusiminen 6–10 vuoden kuluessa\n" },

            { text: "KL 1", bold: true, color: "#ba3b46" },
            { text: " Heikko, uusitaan 1–5 vuoden kuluessa" }
          ],
          fontSize: fontSizeParagraph,
          lineHeight: lineHeightGlobal,
        }
      ],
      margin: [0, 0, 0, 0],
    });

    // Text after the marker
    if (after) {
      content.push({
        text: after,
        style: "paragraph",
        margin: [0, 0, 0, 0],
      });
    }

    return;
  }

  // If marker not found, just render raw content
  content.push({
    text: raw,
    style: "paragraph",
    margin: [0, 0, 0, 0],
  });
}